import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { agregarProducto } from '../../redux/carrito/carritoSlice';
import { productos as toggleFavorito } from '../../redux/favoritos/favoritosSlice';
import { RootState } from '../../redux/store';
import { Producto } from '../../models/Producto';
import { getFotoProductoUrl } from '../../utils/utils';
import { sendSCEvent } from '../../utils/SCEvent';

const useHook = (producto: Producto) => {

  const dispatch = useDispatch();
  const carrito = useSelector((state: RootState) => state.carrito.productos);
  const productosFavoritos = useSelector((state: RootState) => state.favoritos.productos);

  const [hovered, setHovered] = useState(false);

  // El store se precarga desde localStorage de forma sincrónica (redux/store.js),
  // así que en el cliente ya puede tener carrito/favoritos reales mientras el
  // servidor siempre renderiza vacío. Se difiere un tick para evitar mismatch de hidratación.
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const itemEnCarrito = carrito.find((item) => item.producto.id === producto.id);
  const cantidadEnCarrito = mounted ? (itemEnCarrito?.cantidad || 0) : 0;
  const esFavorito = mounted && Boolean(productosFavoritos?.find((p) => p.id === producto.id));

  const mainImage = getFotoProductoUrl(producto.attributes?.fotos?.data?.[0]) || 'https://dummyimage.com/340x340/000000/ffffff';
  const hoverImage = getFotoProductoUrl(producto.attributes?.fotos?.data?.[1]) || mainImage;

  const handleAgregar = () => dispatch(agregarProducto({ cantidad: 1, producto }));
  const handleFavorito = () => dispatch(toggleFavorito(producto));

  const handleImageClick = () => {
    sendSCEvent({
      type: 'click',
      element: 'Botón "Ver detalles"',
      slot: 0,
      detail: `${producto?.attributes?.nombre} || Producto #${producto?.id}`,
      owner: null,
      filter1: producto?.attributes?.tematica?.data?.attributes?.nombre,
      filter2: producto?.attributes?.tipo?.data?.attributes?.nombre,
      filter3: producto?.attributes?.color?.data?.attributes?.nombre,
    });
  };

  return {
    hovered,
    setHovered,
    cantidadEnCarrito,
    esFavorito,
    mainImage,
    hoverImage,
    handleAgregar,
    handleFavorito,
    handleImageClick,
  };
};

export default useHook;
